import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

export const MAX_RETRIES = 3;
export const RETRY_DELAY_MS = 1000;

@Injectable()
export class RetryInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      retry({
        count: MAX_RETRIES,
        delay: (error: HttpErrorResponse | Error, retryCount: number) => {
          // Calculate exponential backoff delay
          const delayTime = RETRY_DELAY_MS * Math.pow(2, retryCount - 1);

          console.log(
            `[RetryInterceptor] Attempt ${retryCount}/${MAX_RETRIES}: Retrying request to ${
              request.urlWithParams
            } in ${delayTime}ms. Error: ${(error as Error).message}`
          );

          // Always return timer for any error
          return timer(delayTime);
        },
      }),
      catchError((error: HttpErrorResponse | Error) => {
        // This will catch errors after all retries are exhausted
        console.error(
          `[RetryInterceptor] Request to ${request.urlWithParams} failed after ${MAX_RETRIES} attempts:`,
          error
        );
        return throwError(() => error);
      })
    );
  }
}
